import { render } from "./one-price.vue?vue&type=template&id=2391bfe6&scoped=true&ts=true"
import script from "./one-price.vue?vue&type=script&lang=ts"
export * from "./one-price.vue?vue&type=script&lang=ts"

import "./one-price.vue?vue&type=style&index=0&id=2391bfe6&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2391bfe6"]])

export default __exports__